import { useState, useEffect, useCallback } from "react";

export const useLocationSuggestions = (input) => {
	const [suggestions, setSuggestions] = useState([]);
	const [loading, setLoading] = useState(false);

	// Debounce function
	const debounce = (func, wait) => {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(() => func(...args), wait);
		};
	};

	// Memoize fetchSuggestions to prevent recreation on every render
	const fetchSuggestions = useCallback(async (searchInput) => {
		if (!searchInput) {
			setSuggestions([]);
			return;
		}

		setLoading(true);
		try {
			//post api call url

			const response = await fetch(
				`https://api.my-cron.com/api/places/autocomplete`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						input: searchInput,
					}),
				}
			);

			const data = await response.json();

			// Updated mapping for v1 API response structure
			const formattedSuggestions =
				data.suggestions?.map((suggestion) => ({
					place_id: suggestion.placePrediction.placeId,
					description: suggestion.placePrediction.text.text,
					mainText: suggestion.placePrediction.structuredFormat.mainText.text,
					secondaryText: suggestion.placePrediction.text.text,
                    types: suggestion.placePrediction.types,
				})) || [];

			setSuggestions(formattedSuggestions);
		} catch (error) {
			console.error("Error fetching suggestions:", error);
			setSuggestions([]);
		} finally {
			setLoading(false);
		}
	}, []);

	// Debounced version of fetchSuggestions
	const debouncedFetch = useCallback(
		debounce((value) => fetchSuggestions(value), 300),
		[fetchSuggestions]
	);

	// Effect to trigger search when input changes
	useEffect(() => {
		debouncedFetch(input);
	}, [input, debouncedFetch]);

	return {
		suggestions,
		loading,
	};
};
